/**
 * The reporting periods a "which securities did this account hold" question
 * is asked over, and the one wire shape the backend parses them back from
 * (`views.parse_held_periods`).
 *
 * It lives here, beside the API modules, rather than in the picker that
 * first needed it: two endpoints now take the parameter — the asset list
 * behind the picker and Bucket 2's "add all holdings" — and an API module
 * must not reach up into a component for the format it sends.
 */

/** One inclusive reporting period, both bounds as "YYYY-MM-DD". */
export type HeldPeriod = [string, string];

/** `[["2024-01-01", "2024-03-31"]]` to `"2024-01-01:2024-03-31"`. */
export const serializeHeldPeriods = (periods: HeldPeriod[] | undefined) =>
  periods?.length
    ? periods.map(([from, to]) => `${from}:${to}`).join(",")
    : undefined;
